<script setup>
 import {onMounted} from "vue";
 import {useI18n} from "vue-i18n";
 import {useUserStore} from "@/stores.ts";
 import { onBeforeUnmount } from 'vue'
 import {useRouter} from "vue-router";

 const { locale } = useI18n()
 const userStore = useUserStore()
 const emit = defineEmits(['openChatWidget']);

 onMounted(async () => {
   await userStore.getUserData()
 })

 onBeforeUnmount(() => {
   document.body.style.overflow = ''
 })

 const router = useRouter()

 const switchLocale = ((l) => {
   router.push({name: l})
   if(l === 'kk') {
     locale.value = l
   }
 })
</script>

<template>
  <SiteHeader @openChatWidget="emit('openChatWidget')"
              @openTanbaAuth="emit('openTanbaAuth')"
              :locale="locale"
              :isAuth="userStore.isAuth"
              :userInfo="userStore.userInfo"
              :host="'https://b2b.telecom.kz'"
              @switchLang="switchLocale($event)"></SiteHeader>
</template>

<style scoped lang="scss">
</style>
